module.exports = __webpack_public_path__ + "img/logos (6).f0e3d67e.png";